import { useState, useEffect } from "react";
import { Loading } from "../Other/Loading";
import axios from "axios";
const Contact_Home = () => {
  const [data, setData] = useState(null);

  

  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/contact`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setData(events.Banner);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);


  if (!data)
    return (
      <div className="flex justify-center items-center h-64">
        <Loading />
      </div>
    );

  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <div className="w-full bg-gradient-to-br from-blue-300 via-blue-100 to-white py-20 px-6 md:px-20 text-center md:text-left">
        <h1 className="text-left text-4xl md:text-6xl font-bold text-gray-800 leading-tight">
          {data.title}
        </h1>
        <div className="h-1 w-20 bg-blue-500 mt-4 mx-auto md:mx-0 rounded"></div>
      </div>

      {/* Description */}
      <div className="max-w-4xl mx-auto px-6 py-10 md:py-14 text-center md:text-left">
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
          {data.description}
        </p>
      </div>
    </div>
  );
};

export default Contact_Home;
